module.exports = __webpack_public_path__ + "img/test-1-image@3x.15d9a246.png";